/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { combineReducers } from "redux";
import { authCustomerReducer } from "cms/store/reducers/auth-customer";

const reducers = combineReducers({
    authCustomer: authCustomerReducer,
});

export default reducers;
